// ============================================================================
// INTERRUPTOR DOS NÚMEROS DE DESTAQUE (secção inicial / Hero)
// ----------------------------------------------------------------------------
// A empresa é nova e ainda não tem histórico real (nº de condomínios geridos,
// anos de experiência, clientes satisfeitos, resposta média).
// Por isso os números estão OCULTOS no site, mas o código e os dados ficam aqui.
//
// PARA VOLTAR A MOSTRAR MAIS TARDE:
//   1) Quando a empresa já tiver estes números reais, atualize os valores em `stats` abaixo.
//   2) Mude `showHeroStats` de `false` para `true`.
//   Pronto — o bloco de números volta a aparecer automaticamente no topo do site.
// ============================================================================
export const showHeroStats = false;

// ============================================================================
// INTERRUPTOR DO HORÁRIO DE ATENDIMENTO (secção de Contactos)
// ----------------------------------------------------------------------------
// A empresa é nova e ainda não tem horário de atendimento definido
// ("Segunda a sexta, 9h–19h"). Por isso o horário está OCULTO no site, junto
// ao número de telemóvel, mas o texto fica guardado aqui.
//
// PARA VOLTAR A MOSTRAR MAIS TARDE:
//   1) Quando a empresa já tiver horário definido, ajuste o texto em
//      `company.hours` abaixo (se precisar de outro horário).
//   2) Mude `showContactHours` de `false` para `true`.
//   Pronto — a linha do horário volta a aparecer automaticamente por baixo
//   do número de telemóvel, na secção de Contactos.
// ============================================================================
export const showContactHours = false;

// ============================================================================
// INTERRUPTOR DO MAPA (secção de Contactos)
// ----------------------------------------------------------------------------
// A empresa ainda não tem escritório fixo com morada, por isso o mapa está
// OCULTO no site, mas o código e o endereço ficam aqui.
//
// PARA VOLTAR A MOSTRAR MAIS TARDE:
//   1) Quando a empresa já tiver um escritório com morada, ajuste a morada no
//      mapa em `src/pages/home/components/Contact.tsx`.
//   2) Mude `showMap` de `false` para `true`.
//   Pronto — o mapa volta a aparecer automaticamente no fim da secção de Contactos.
// ============================================================================
export const showMap = false;

export const company = {
  name: "Porta31 Condomínios",
  shortName: "Porta31",
  slogan: "Gestão eficiente, tranquilidade garantida.",
  owner: "Marta Faustino",
  ownerRole: "Administradora da Porta31",
  phoneDisplay: "+351 917 097 085",
  phoneRaw: "351917097085",
  email: "porta31condominios@gmail.com",
  location: "Vila Nova de Famalicão, Portugal",
  instagram: "https://www.instagram.com/porta31condominios",
  facebook: "https://www.facebook.com/share/1BwUsXhhru/",
  whatsapp: "https://wa.me/351917097085",
  hours: "Segunda a sexta, 9h–19h.",
  logo: "/imagens-logo/logo-porta31-sf.png",
  ownerPhoto: "/imagens-administradora/administradora-home.webp",
};

export const navLinks = [
  { id: "sobre", label: "Sobre Nós" },
  { id: "servicos", label: "Serviços" },
  { id: "galeria", label: "Manutenção" },
  { id: "novidades", label: "Dicas" },
  { id: "reunioes", label: "Reuniões" },
  { id: "contactos", label: "Contactos" },
];

export const stats = [
  { value: "150+", label: "Condomínios geridos" },
  { value: "12", label: "Anos de experiência" },
  { value: "98%", label: "Clientes satisfeitos" },
  { value: "24h", label: "Resposta média" },
];

export const values = [
  {
    icon: "shield-check",
    title: "Transparência",
    text: "Contas claras, relatórios acessíveis e decisões sempre comunicadas a todos os condóminos.",
  },
  {
    icon: "heart-handshake",
    title: "Proximidade",
    text: "Um atendimento humano e dedicado, com total disponibilidade para ouvir cada condómino.",
  },
  {
    icon: "line-chart",
    title: "Rigor",
    text: "Gestão financeira organizada, cumprimento de obrigações legais e controlo de custos.",
  },
  {
    icon: "leaf",
    title: "Valorização",
    text: "Cuidamos do seu património para preservar e aumentar o valor do seu imóvel.",
  },
];

export const services = [
  {
    icon: "clipboard-list",
    title: "Gestão Administrativa e Financeira",
    text: "Orçamentos, contabilidade, cobrança de quotas e relatórios periódicos de receitas e despesas, sempre com total transparência.",
  },
  {
    icon: "wrench",
    title: "Manutenção e Conservação",
    text: "Acompanhamento de manutenções preventivas e corretivas, coordenação de obras e fiscalização de fornecedores.",
  },
  {
    icon: "users",
    title: "Assembleias de Condóminos",
    text: "Convocação, preparação de documentação e moderação de assembleias, garantindo decisões participadas e legais.",
  },
  {
    icon: "scale",
    title: "Apoio Jurídico",
    text: "Acompanhamento no cumprimento das obrigações legais e mediação de conflitos entre condóminos.",
  },
];

export const gallery = [
  {
    id: "exteriores",
    src: "/imagens-servicos/servicos-exteriores.webp",
    alt: "Zonas exteriores partilhadas de um condomínio com piscina",
    title: "Zonas exteriores",
    category: "Espaços exteriores",
    excerpt:
      "Piscinas, jardins, regas e terraços comuns — tudo coordenado por nós para que se mantenham bonitos, seguros e funcionais todo o ano.",
    content: [
      {
        heading: "Jardins e espaços verdes",
        text: "Contratação de jardineiro, corte de relva, poda de árvores e arbustos, plantação sazonal e tratamento fitossanitário.",
      },
      {
        heading: "Piscina",
        text: "Limpeza, tratamento e equilíbrio da água, e manutenção dos equipamentos de filtragem e bombagem.",
      },
      {
        heading: "Sistema de rega",
        text: "Verificação de aspersores e programadores, ajuste dos horários por estação e deteção de fugas.",
      },
      {
        heading: "Terraços e mobiliário comum",
        text: "Limpeza, tratamento de madeiras e reparação de mobiliário e zonas de lazer.",
      },
      {
        heading: "Espaço infantil e áreas de lazer",
        text: "Inspeção de segurança regular e manutenção dos equipamentos.",
      },
    ],
  },
  {
    id: "entradas",
    src: "/imagens-servicos/servicos-entradas.webp",
    alt: "Hall de entrada de um condomínio elegante com elevador moderno",
    title: "Entradas e halls",
    category: "Zonas comuns interiores",
    excerpt:
      "As primeiras zonas que qualquer pessoa vê — limpas, cuidadas e bem conservadas, todos os dias.",
    content: [
      {
        heading: "Limpeza das zonas comuns",
        text: "Halls, escadas, corredores, cabines de elevador e vidros, com periodicidade definida.",
      },
      {
        heading: "Manutenção de elevadores",
        text: "Contrato de manutenção preventiva e acompanhamento das inspeções obrigatórias.",
      },
      {
        heading: "Iluminação interior",
        text: "Substituição de lâmpadas, iluminação LED e sensores de presença nas zonas de passagem.",
      },
      {
        heading: "Conservação e pequenas reparações",
        text: "Pintura de paredes, reparação de pavimentos, rodapés e portas.",
      },
      {
        heading: "Portaria e videoporteiro",
        text: "Manutenção dos equipamentos de comunicação e controlo de acessos.",
      },
    ],
  },
  {
    id: "fachadas",
    src: "/imagens-servicos/servicos-fachadas.webp",
    alt: "Fachada de um edifício residencial moderno",
    title: "Fachadas e arquitetura",
    category: "Envolvente do edifício",
    excerpt:
      "A imagem do edifício é a sua carta de apresentação — cuidamos das fachadas, coberturas e caixilharias.",
    content: [
      {
        heading: "Lavagem e tratamento de fachadas",
        text: "Limpeza periódica e tratamento dos revestimentos para preservar o aspeto original.",
      },
      {
        heading: "Pintura e reparação",
        text: "Correção de fissuras, betonilhas e tratamento de impermeabilizações.",
      },
      {
        heading: "Coberturas e caleiras",
        text: "Limpeza de telhados, caleiras e ralos, com reforço antes do inverno.",
      },
      {
        heading: "Caixilharias e estores",
        text: "Manutenção e reparação de janelas, portas e estores.",
      },
      {
        heading: "Inspeção técnica periódica",
        text: "Acompanhamento do estado geral da envolvente do edifício.",
      },
    ],
  },
  {
    id: "garagens",
    src: "/imagens-servicos/servicos-garagens.webp",
    alt: "Estacionamento subterrâneo organizado",
    title: "Garagens e estacionamento",
    category: "Estacionamento",
    excerpt:
      "Garagens limpas, seguras e bem organizadas, com tudo a funcionar como deve ser.",
    content: [
      {
        heading: "Limpeza",
        text: "Pavimentos, rampas, escadas de acesso e zonas de circulação.",
      },
      {
        heading: "Sinalização e marcações",
        text: "Marcação de lugares, sinalética de segurança e percursos de evacuação.",
      },
      {
        heading: "Iluminação e ventilação",
        text: "Manutenção dos sistemas que garantem visibilidade e renovação de ar.",
      },
      {
        heading: "Portões automáticos e acessos",
        text: "Revisão e manutenção de portões, comandos e barreiras.",
      },
      {
        heading: "Sistemas de bombagem",
        text: "Verificação dos sistemas de escoamento e bombagem de águas.",
      },
    ],
  },
];

export const news = [
  {
    id: "custos",
    src: "/imagens-dicas/dicas-custos.webp",
    alt: "Mesa de planeamento do orçamento de um condomínio",
    title: "5 formas de reduzir os custos do seu condomínio",
    excerpt:
      "Pequenas decisões de manutenção e negociação de contratos podem poupar centenas de euros por ano a todos os condóminos.",
    category: "Gestão financeira",
    content: [
      {
        heading: "",
        text: "Gerir um condomínio é, acima de tudo, gerir um orçamento comum. Todos os anos, o valor das quotas é decidido em assembleia e, muitas vezes, grande parte dele vai para custos que podem ser reduzidos com planeamento e negociação. Estas são as cinco medidas com maior impacto na carteira de todos os condóminos.",
      },
      {
        heading: "1. Renegocie os contratos de manutenção",
        text: "Os contratos de limpeza, elevadores, jardins e segurança tendem a renovar-se ano após ano sem revisão. Pedir pelo menos três orçamentos alternativos e renegociar o valor atual costuma poupar entre 10% e 20% em cada contrato.",
      },
      {
        heading: "2. Aposte na manutenção preventiva",
        text: "Revisões periódicas a elevadores, caldeiras e sistemas de bombagem evitam avarias graves. Um pequeno custo anual de manutenção preventiva evita reparações de milhares de euros e o desgaste acelerado dos equipamentos.",
      },
      {
        heading: "3. Controle os consumos de energia e água",
        text: "A iluminação das zonas comuns, os sistemas de bombagem e a rega automática são os maiores consumidores. Lâmpadas LED, sensores de presença e temporizadores de rega reduzem a fatura mensal de forma consistente.",
      },
      {
        heading: "4. Compare seguros e atualize o capital seguro",
        text: "O seguro do edifício deve ser revisto todos os anos. Muitos condomínios pagam mais do que deviam por capitais desajustados ou coberturas duplicadas. Comparar propostas pode baixar o prémio sem perder proteção.",
      },
      {
        heading: "5. Recupere dívidas de quotas com regularidade",
        text: "As quotas em atraso obrigam o condomínio a avançar com dinheiro próprio, criando desequilíbrios financeiros. Definir um plano de cobrança claro e atuar cedo evita acumular dívidas difíceis de recuperar.",
      },
      {
        heading: "",
        text: "Aplicadas em conjunto, estas medidas podem representar poupanças de vários milhares de euros por ano — dinheiro que fica no fundo comum e evita aumentos desnecessários de quotas.",
      },
    ],
  },
  {
    id: "manutencao",
    src: "/imagens-dicas/dicas-manutencao.webp",
    alt: "Técnico a inspecionar a fachada de um condomínio",
    title: "Manutenção preventiva: quando e porquê",
    excerpt:
      "Antecipar reparações evita obras caras e valoriza o edifício. Saiba o calendário essencial que cada condomínio devia seguir.",
    category: "Manutenção",
    content: [
      {
        heading: "",
        text: "A manutenção preventiva é o melhor investimento que um condomínio pode fazer na sua própria longevidade. Em vez de reagir a avarias, o objetivo é antecipá-las, mantendo o edifício seguro, eficiente e valorizado ao longo do tempo.",
      },
      {
        heading: "Porque é tão importante",
        text: "Grande parte das reparações caras começa com problemas pequenos e ignorados: uma infiltração mínima que se transforma em humidade estrutural, um elevador sem revisão que pára de repente, uma caldeira sem limpeza que perde rendimento. A manutenção preventiva corta o problema pela raiz e dilui os custos ao longo do ano.",
      },
      {
        heading: "O calendário essencial",
        text: "Elevadores: revisão trimestral obrigatória. Sistemas de bombagem e água quente: verificação semestral. Coberturas, caleiras e ralos: limpeza duas vezes por ano, antes do inverno. Fachadas e caixilharias: inspeção anual. Jardins e regas: manutenção contínua com reforço na primavera.",
      },
      {
        heading: "Quem deve acompanhar",
        text: "A administração deve manter um plano anual de manutenção, com registo das intervenções e respetivos custos. Este histórico é essencial para justificar decisões em assembleia e para negociar melhor com fornecedores.",
      },
      {
        heading: "",
        text: "Um edifício bem mantido vale mais no mercado, dá menos dores de cabeça aos condóminos e evita os sustos financeiros das obras de emergência.",
      },
    ],
  },
  {
    id: "assembleia",
    src: "/imagens-dicas/dicas-assembleia.webp",
    alt: "Sala de reuniões preparada para uma assembleia de condóminos",
    title: "Como preparar uma assembleia de condóminos",
    excerpt:
      "Convocatórias, ordem de trabalhos e quórum: um guia simples para reuniões produtivas e sem surpresas desagradáveis.",
    category: "Assembleias",
    content: [
      {
        heading: "",
        text: "Uma assembleia bem preparada resolve mais em duas horas do que uma assembleia improvisada em quatro. O segredo está na organização prévia: documentos certos, ordem de trabalhos clara e regras de participação bem definidas.",
      },
      {
        heading: "Convoque a reunião com antecedência",
        text: "A convocatória deve ser enviada a todos os condóminos com a antecedência prevista na lei e incluir a data, a hora, o local e a ordem de trabalhos completa. Assuntos que não constem da ordem de trabalhos não podem, em regra, ser votados.",
      },
      {
        heading: "Prepare a documentação",
        text: "Orçamentos, relatórios de contas, propostas de obras e certidões de dívida devem estar disponíveis antes da reunião. Quanto mais informação circular antecipadamente, menos tempo se perde a discutir detalhes no momento.",
      },
      {
        heading: "Garanta o quórum",
        text: "A validade das deliberações depende do número de condóminos presentes e das maiorias exigidas para cada tipo de assunto. Verifique antes da reunião se há quórum suficiente e o que fazer caso não exista.",
      },
      {
        heading: "Registe tudo em ata",
        text: "A ata é o documento que dá força legal às decisões. Deve refletir com rigor os pontos discutidos, as votações e os resultados, sendo assinada por quem a elaborou e pelo presidente da mesa.",
      },
      {
        heading: "",
        text: "Com preparação, uma assembleia deixa de ser um momento de tensão e passa a ser uma reunião produtiva, onde as decisões importantes avançam de forma clara e participada.",
      },
    ],
  },
  {
    id: "obras",
    src: "/imagens-dicas/dicas-obras.webp",
    alt: "Obras de renovação numa zona comum de um edifício",
    title: "Obras em partes comuns: o que precisa de saber",
    excerpt:
      "Antes de aprovar uma obra, conheça as regras de maioria, o impacto nas quotas e os passos legais a cumprir.",
    category: "Obras",
    content: [
      {
        heading: "",
        text: "As obras em partes comuns são das decisões mais importantes que um condomínio pode tomar. Além do valor, envolvem regras de maioria, prazos e um impacto direto na vida de todos os condóminos. Conhecer o processo evita conflitos e surpresas.",
      },
      {
        heading: "Distinguir conservação de inovação",
        text: "Obras de conservação (reparar, recuperar ou substituir) exigem apenas maioria simples dos presentes. Já as obras de inovação (melhorias que aumentam o conforto ou o valor) exigem maioria qualificada, normalmente dois terços dos condóminos.",
      },
      {
        heading: "As maiorias contam",
        text: "O número de votos de cada condómino corresponde à sua permilagem no condomínio. É por isso essencial conhecer o valor de cada fração antes de votar, pois as maiorias são calculadas sobre o valor total do edifício.",
      },
      {
        heading: "Orçamento e prazos realistas",
        text: "Peça várias propostas, verifique licenças e prazos de execução e reserve uma margem para imprevistos. Um bom plano de obra inclui cronograma, faseamento e regras de convivência durante os trabalhos.",
      },
      {
        heading: "Comunicação e acompanhamento",
        text: "Manter os condóminos informados sobre o andamento da obra e as alterações ao plano inicial é fundamental para a confiança coletiva. A administração deve reportar o progresso com regularidade.",
      },
      {
        heading: "",
        text: "Bem conduzidas, as obras valorizam o edifício, melhoram a qualidade de vida e reforçam a união entre condóminos. Mal geridas, tornam-se uma fonte de conflitos — a diferença está quase sempre na preparação.",
      },
    ],
  },
  {
    id: "vizinhos",
    src: "/imagens-dicas/dicas-vizinhos.webp",
    alt: "Corredor de um edifício residencial com duas portas de apartamento",
    title: "Vizinhos em conflito: como resolver com bom senso",
    excerpt:
      "Ruído, obras e partes comuns são as causas mais frequentes. Conheça a via do diálogo e quando envolver a administração.",
    category: "Convivência",
    content: [
      {
        heading: "",
        text: "Num condomínio vive-se em proximidade, e isso traz desafios naturais de convivência. Ruído, obras, animais, estacionamento e uso das partes comuns estão entre as queixas mais frequentes. A boa notícia é que a maioria se resolve com diálogo e bom senso.",
      },
      {
        heading: "Comece pelo diálogo direto",
        text: "Muitas vezes, quem está do outro lado nem se apercebe do incómodo. Uma conversa educada, feita no momento certo e no tom certo, resolve grande parte dos casos antes de se tornar problema.",
      },
      {
        heading: "Conheça o regulamento",
        text: "O regulamento do condomínio define regras concretas: horários de obras, uso de zonas comuns, circulação e ruído. Recorrer a ele dá objetividade à conversa e tira o tom pessoal do conflito.",
      },
      {
        heading: "Quando envolver a administração",
        text: "Se o diálogo direto falhar, a administração pode mediar e enviar comunicações formais. O seu papel é procurar equilíbrio e garantir que o regulamento é cumprido por todos, sem tomar partidos.",
      },
      {
        heading: "Em último caso, a via legal",
        text: "Situações graves de ruído ou de uso indevido das partes comuns podem ser resolvidas pelas entidades competentes. É o último recurso, mas está disponível quando o bom senso se esgota.",
      },
      {
        heading: "",
        text: "Viver bem num condomínio é um exercício constante de respeito partilhado. Tolerância de um lado e consideração do outro fazem mais pela convivência do que qualquer cláusula de regulamento.",
      },
    ],
  },
  {
    id: "seguranca",
    src: "/imagens-dicas/dicas-seguranca.webp",
    alt: "Entrada de um condomínio com sistema de videovigilância",
    title: "Segurança no condomínio: medidas que fazem a diferença",
    excerpt:
      "Portas, videovigilância e boa iluminação nas zonas comuns protegem o edifício. Veja como organizar estas medidas em conjunto.",
    category: "Segurança",
    content: [
      {
        heading: "",
        text: "A segurança de um condomínio constrói-se com pequenas medidas coordenadas, não com grandes sistemas isolados. Portas, iluminação, videovigilância e hábitos de prevenção trabalham juntos para proteger pessoas e património.",
      },
      {
        heading: "Controlo dos acessos",
        text: "O controlo dos acessos é a primeira linha de defesa. Portas com fecho automático, videoporteiros funcionais e registo de visitantes reduzem muito a entrada de estranhos no edifício.",
      },
      {
        heading: "Iluminação das zonas comuns",
        text: "Áreas bem iluminadas desencorajam intrusões e aumentam a sensação de segurança. Luzes com sensores em garagens, escadas e entradas garantem visibilidade durante a noite sem disparar o consumo.",
      },
      {
        heading: "Videovigilância bem planeada",
        text: "As câmaras devem cobrir entradas, garagens e zonas comuns, respeitando a legislação de proteção de dados, com sinalização adequada e regras claras de acesso às gravações.",
      },
      {
        heading: "Regras comuns e vigilância entre vizinhos",
        text: "Fechar bem as portas, cuidar das chaves e estar atento faz toda a diferença. Regras simples, partilhadas por todos, valem tanto como qualquer equipamento instalado.",
      },
      {
        heading: "",
        text: "A segurança é um trabalho coletivo: equipamentos certos, hábitos responsáveis e boa vizinhança criam um condomínio mais tranquilo e protegido.",
      },
    ],
  },
];